
// Mailchimp customer tags functionality
function passingMcTags(ele,tagsId){
    let checkboxStatus = document.getElementById(ele.id);
    let updateValue = checkboxStatus.getAttribute('data-tag')
    let tagsValue = document.getElementById(tagsId);
    if (checkboxStatus.checked) {
        tagsValue.value += ','+updateValue;   
    } else {
        let replaceValue = tagsValue.value.replace(','+updateValue,'');
        tagsValue.value = replaceValue;
    }
}

// CDP tags functionality code goes here according to checkbox checked.
function passingCdpMcTags(ele,tagsId){
    if(theme.settings.enable_multi_tags){
        let hiddenInput = document.getElementById(tagsId);
        let checkbox_Status = document.getElementById(ele.id);
        let update_tagValue = checkbox_Status.getAttribute('data-checkbox');
        if (checkbox_Status.checked && update_tagValue) {
            hiddenInput.value = hiddenInput.value+','+update_tagValue;
        } else {
            if(update_tagValue){
                let tagsValues = hiddenInput.value;
                let newstringValue = tagsValues.replace(','+update_tagValue, "");
                hiddenInput.value = newstringValue;
            } 
        }
        
    }else{
        let checkboxStatus = document.getElementById(ele.id);
        let updateBothTag = checkboxStatus.getAttribute('data-both-checkbox')
        let updateSingleTag = checkboxStatus.getAttribute('data-single-checkbox')
        let tagsValue = document.getElementById(tagsId);
        if (checkboxStatus.checked) {
            let tagsValues = tagsValue.value;
            let newstring = tagsValues.replace(updateSingleTag, updateBothTag);
            tagsValue.value = newstring;
        } else {
            let tagsValues = tagsValue.value;
            let newstring = tagsValues.replace(updateBothTag, updateSingleTag);
            tagsValue.value = newstring;
        }
    }
}
    

// Mailchimp DOB field functionality goes here.
const dayInput = document.getElementById("mce-BIRTHD-day");
const monthInput = document.getElementById("mce-BIRTHD-month");

if (dayInput) {
    dayInput.addEventListener("input", cloneInputValue);
}
if (monthInput) {
    monthInput.addEventListener("input", cloneInputValue);
}

function cloneInputValue(event) {
    if (event.currentTarget.id == 'mce-BIRTHD-day'){
        document.getElementById('mce-BDAY-day').value= event.currentTarget.value;
    }
    if (event.currentTarget.id == 'mce-BIRTHD-month'){
        document.getElementById('mce-BDAY-month').value= event.currentTarget.value;
    }
}